/* swiper不支持Image组件，精选视频 */
import React, { useEffect, useState, SyntheticEvent } from 'react'
import { useInView } from 'react-intersection-observer'
import useVisible from 'Components/hooks/use-visible'
import formatDuration from 'lib/format-duration'
import classnames from 'classnames'
import ArticleLink from 'Components/links/article-link'
import { IFeedData } from 'lib/fetch-feed'
import Link from 'next/link'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper'
import applyHttpsImage from 'lib/apply-https-img'
import get from 'lodash/get'

SwiperCore.use([Navigation, Pagination, Autoplay])

const video_icon = require('../../public/static/large-video-icon.png')
interface IProps {
  featuredVideos: IFeedData[]
  articleList: ArticleData[]
}

interface IVideo {
  name: string
  column_id: number
}

export interface ArticleData {
  gid: number
  gid_str: string
  title: string
  count: number
  type: number
}
const videoTitle = [
  {
    name: '大神评测官',
    column_id: 128,
  },
  {
    name: '38号车评中心',
    column_id: 111,
  },
  {
    name: '明星评测官',
    column_id: 144,
  },
  {
    name: '丈母娘唠车',
    column_id: 131,
  },
]

export default function FeaturedVideos({
  featuredVideos,
  articleList = [],
}: IProps) {
  const FRAME_TIMES = 3

  const [ref, inView] = useInView({
    threshold: 0,
  })
  const isVisible = useVisible()
  const [hasShow, setHasShow] = useState(false)
  useEffect(() => {
    if (!hasShow && inView && isVisible && featuredVideos.length) {
      sendTeaCommEvent('show_selected_video_list')
      sendTeaCommEvent('web_client_show', {
        list_type: 1,
        item_type: 1,
        key_name: 'home_hot_video_card',
      })
      setHasShow(true)
    }
  }, [featuredVideos, hasShow, inView, isVisible])
  const params = {}
  return (
    <div className="featured-videos-wrapper" id="featured_videos">
      <section
        className="featured-videos home-feature-videos"
        ref={ref}
        onClick={(e: SyntheticEvent) => {
          const target = e.target as HTMLElement
          const prevPressed = target.classList.contains('swiper-nav-pre')
          const nextPressed = target.classList.contains('swiper-nav-next')
          if (prevPressed || nextPressed) {
            sendTeaCommEvent('click_excellent_video_switch', {
              switch_direction: nextPressed ? 'right' : 'left',
            })
            return
          }
        }}
      >
        <div className="videos-wrapper">
          <div className="title fl">
            <h2>精选视频</h2>
          </div>
          <ul className="video-title-list">
            {videoTitle.map((item: IVideo) => (
              <li
                className="title-item fl"
                key={item.column_id}
                onClick={() => {
                  sendTeaCommEvent('click_excellent_video_card_desc', {
                    program_id: item.column_id,
                  })
                }}
              >
                <Link
                  href={`/video/group?groupId=${item.column_id}`}
                  as={`/video/groups/${item.column_id}`}
                >
                  <a target="_blank" title={item.name}>
                    {item.name}
                  </a>
                </Link>
              </li>
            ))}
          </ul>
          <div className="fr">
            <Link href="/video/home" as={'/video'}>
              <a
                target="_blank"
                className="more"
                onClick={() => {
                  sendTeaCommEvent('click_excellent_video_card_channel')
                }}
              >
                进入视频频道
                <i className="more-icon icon-arrow-ic-r" />
              </a>
            </Link>
          </div>
        </div>
        <Swiper
          watchOverflow={true}
          pagination={{
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          }}
          navigation={{
            nextEl: '.swiper-nav-next',
            prevEl: '.swiper-nav-pre',
          }}
          autoplay={{
            delay: 8000,
            disableOnInteraction: false,
          }}
          loop={true}
          spaceBetween={30}
          slidesPerView={1}
          onSlideChangeTransitionStart={swiper => {
            const activeIndex =
              (get(swiper, 'activeIndex', 1) - 1 + FRAME_TIMES) % FRAME_TIMES
            sendTeaCommEvent('show_excellent_car_video_card', {
              rank: activeIndex,
            })
          }}
        >
          {new Array(FRAME_TIMES)
            .fill(undefined)
            .map((item: number, index: number) => {
              const currentIndex = index * 5
              const videoList = featuredVideos.slice(
                currentIndex + 1,
                currentIndex + 5
              )
              const videoBig = featuredVideos[currentIndex]
              if (!videoBig) {
                return <div />
              }
              return (
                <SwiperSlide key={videoBig.unique_id_str}>
                  <div className="videos" key={videoBig.unique_id_str}>
                    <div className="left-section fl">
                      <ArticleLink gid={videoBig.unique_id_str}>
                        <div className="video-transition">
                          <div
                            className="big-video-wrapper"
                            onClick={() => {
                              sendTeaCommEvent(
                                'click_excellent_video_card_item',
                                {
                                  group_id: videoBig.unique_id_str,
                                  rank: index,
                                  item_rank: 0,
                                }
                              )
                            }}
                          >
                            <div
                              className="big-video"
                              style={{
                                backgroundImage: `url(${applyHttpsImage(
                                  get(videoBig, 'info.image_list[0].url', '')
                                )})`,
                              }}
                            >
                              <div className="video-icon" />
                            </div>
                          </div>

                          <div className="pic-title">
                            <div className="title">
                              {get(
                                featuredVideos,
                                `[${currentIndex}].info.title`,
                                ''
                              )}
                            </div>
                          </div>
                        </div>
                      </ArticleLink>
                    </div>
                    <div className="right-section fr">
                      {videoList.map(
                        (infoItem: IFeedData, infoIndex: number) => (
                          <div
                            className="small-video-wrapper"
                            key={infoItem.unique_id_str}
                          >
                            <ArticleLink gid={infoItem.unique_id_str}>
                              <div className="video-transition">
                                <div
                                  className="small-video"
                                  style={{
                                    backgroundImage: `url(${applyHttpsImage(
                                      get(
                                        infoItem,
                                        'info.image_list[0].url',
                                        ''
                                      )
                                    )})`,
                                  }}
                                  onClick={() => {
                                    sendTeaCommEvent(
                                      'click_excellent_video_card_item',
                                      {
                                        group_id: videoBig.unique_id_str,
                                        rank: index,
                                        item_rank: infoIndex + 1,
                                      }
                                    )
                                  }}
                                >
                                  <div className="small-video-icon">
                                    {formatDuration(
                                      get(infoItem, 'info.video_duration', '')
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="pic-title">
                                <div className="title">
                                  {get(infoItem, `info.title`, '')}
                                </div>
                              </div>
                            </ArticleLink>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          <div className="banner-swiper-pagination swiper-pagination tw-flex" />
          <div className="swiper-nav-next" />
          <div className="swiper-nav-pre" />
        </Swiper>
      </section>
      <section className="car-gid-wrapper">
        <div className="videos-wrapper">
          <div className="title">
            <h2>视频排行榜</h2>
          </div>
        </div>
        <ul style={{ marginTop: '1px' }}>
          {Array.isArray(articleList) &&
            articleList.slice(0, 10).map((item, index) => {
              return (
                <li key={item.gid_str} className="line-1">
                  <ArticleLink
                    gid={item.gid_str}
                    onClick={(gid: string) => {
                      sendTeaCommEvent('click_home_top_video', {
                        group_id: item.gid_str,
                      })
                    }}
                    className="line-1"
                  >
                    <span className={classnames(`gid-index gid-${index}`)}>
                      {index + 1}
                      {index < 3 ? null : '.'}
                    </span>
                    <span
                      className={classnames('gid-title', {
                        'gid-title-bold': index < 3,
                      })}
                    >
                      {item.title}
                    </span>
                  </ArticleLink>
                  <span className="gid-count">{item.count}万次播放</span>
                </li>
              )
            })}
        </ul>
      </section>
      <style jsx>
        {`
          .featured-videos-wrapper {
            display: flex;
            padding-top: 40px;
          }
          .featured-videos {
            width: 800px;
          }
          .videos-wrapper {
            height: 36px;
            line-height: 36px;
            margin-bottom: 16px;
          }
          .title h2 {
            font-size: 24px;
            font-weight: 500;
            color: #1a1a1a;
          }
          .video-title-list {
            display: inline-block;
            margin: 0 20px 0 40px;
            font-size: 16px;
            color: #1a1a1a;
          }
          .title-item {
            cursor: pointer;
          }
          .title-item:not(:last-child)::after {
            content: '|';
            padding: 0 8px;
            color: #e6e6e6;
          }
          .more {
            font-size: 16px;
            color: #1a1a1a;
            text-decoration: none;
          }
          .more-icon {
            margin: -2px 0 0 4px;
          }
          .fr {
            float: right;
          }
          .videos {
            width: 100%;
            height: 355px;
          }
          .left-section {
            width: 380px;
          }
          .big-video-wrapper {
            width: 380px;
            height: 280px;
            padding: 33px 0;
            over-flow: hidden;
            border-radius: 2px;
            background-color: black;
          }
          .big-video {
            width: 100%;
            height: 214px;
            transition: background 0.3s ease-in-out;
            background-position: center;
            background-size: 100% 100%;
            position: relative;
          }
          .big-video:hover,
          .small-video:hover {
            background-size: 110% 110%;
          }
          .video-transition {
            overflow: hidden;
          }
          .video-icon {
            width: 60px;
            height: 60px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .video-icon::before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 54%;
            transform: translate(-50%, -50%);
            background: url(${video_icon}) no-repeat center / cover;
            width: 100%;
            height: 100%;
          }
          .right-section {
            width: 420px;
            display: flex;
            flex-wrap: wrap;
          }
          .small-video-wrapper {
            width: 194px;
            margin-left: 16px;
            margin-bottom: 8px;
            border-radius: 2px;
          }
          .small-video {
            width: 194px;
            height: 110px;
            overflow: hidden;
            position: relative;
            font-size: 10px;
            color: #ffffff;
            transition: background 0.3s ease-in-out;
            background-position: center;
            background-size: 100% 100%;
          }
          .small-video-icon {
            padding: 0 4px;
            position: absolute;
            bottom: 8px;
            right: 8px;
            height: 20px;
            line-height: 20px;
            border-radius: 15px;
            background-color: rgba(0, 0, 0, 0.4);
            text-align: center;
            min-width: 47px;
          }
          .small-video-icon::before {
            content: '';
            display: inline-block;
            background: url(//p.pstatp.com/origin/dc14000d8e436aea872a)
              no-repeat center / cover;
            width: 12px;
            height: 12px;
          }
          .pic-title {
            display: flex;
            height: 52px;
            width: 100%;
            align-items: center;
            color: #1f2129;
            background: #f2f4fa;
          }
          .pic-title:hover {
            color: #e65800;
          }
          .videos .title {
            max-height: 52px;
            max-width: 100%;
            padding: 0 12px;
            display: -webkit-box;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .left-section .pic-title {
            font-size: 16px;
            line-height: 22px;
            font-weight: bold;
          }
          .right-section .pic-title {
            font-size: 14px;
            line-height: 20px;
          }
          :global(.home-feature-videos .swiper-button-prev, .home-feature-videos
              .swiper-button-next) {
            height: 48px;
            width: 32px;
            opacity: 1;
            background: rgba(0, 0, 0, 0.4);
            margin-top: -24px;
          }
          :global(.home-feature-videos
              .swiper-button-prev:after, .home-feature-videos
              .swiper-button-next:after) {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 12px;
            left: 4px;
            background-image: url(${require('static/left-ic.png')});
            background-size: cover;
            margin: 0;
          }
          :global(.home-feature-videos
              .swiper-button-prev:hover, .home-feature-videos
              .swiper-button-next:hover) {
            background: #f5b330;
            opacity: 1;
          }
          :global(.home-feature-videos .swiper-button-prev:after) {
            transform: rotateZ(-180deg);
          }
          :global(.home-feature-videos .swiper-pagination-bullet) {
            width: 8px;
            height: 4px;
            border-radius: 0;
            background: #c9cbd6;
            opacity: 1;
          }
          :global(.home-feature-videos .swiper-pagination-bullet-active) {
            width: 16px;
            background: #ffcd32;
          }
          :global(.home-feature-videos .banner-swiper-pagination) {
            @apply tw-w-100 tw-absolute tw-h-4 tw-bottom-8 tw-z-1 tw-items-center tw-justify-end;
            left: 50%;
            transform: translate(-50%, 0);
          }
          :global(.home-feature-videos .banner-bullet) {
            @apply tw-h-4 tw-bg-white tw-mr-4 tw-cursor-pointer;
            width: 8px;
            margin: 0 4px;
            background-color: #c9cbd6;
          }
          :global(.home-feature-videos .banner-bullet.banner-active-bullet) {
            width: 16px;
            background-color: #ffcd32;
          }
          .car-gid-wrapper {
            width: 380px;
            margin-left: 16px;
          }
          .car-gid {
            width: 380px;
            height: 260px;
            border-radius: 2px;
          }
          .line-1 {
            margin-bottom: 17px;
            display: flex;
            width: 100%;
          }
          .line-1:last-child {
            margin-bottom: 0;
          }
          .gid-index {
            display: inline-block;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 18px;
            letter-spacing: normal;
            color: #979aa8;
            width: 18px;
            height: 18px;
            border-radius: 2px;
            text-align: center;
            margin-right: 8px;
          }
          .gid-0 {
            background-color: #e62021;
            color: #ffffff;
          }
          .gid-1 {
            background-color: #e65800;
            color: #ffffff;
          }
          .gid-2 {
            background-color: #f5b330;
            color: #ffffff;
          }
          .gid-title {
            font-size: 14px;
          }
          .gid-title-bold {
            font-weight: 500;
          }
          .gid-count {
            margin-left: auto;
            font-size: 12px;
            color: #979aa8;
            padding-left: 12px;
          }
        `}
      </style>
    </div>
  )
}
